import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

import {
    openRegisterYourInterest,
    resetCustomerType,
    resetRegisterYourInterest,
    setCustomerType,
} from "../actions/register-your-interest.actions";

import {
    CustomerType,
    RegisterYourInterestState,
} from "../models/register-your-interest.models";

import {
    selectRegisterYourInterestCustomerType,
    selectRegisterYourInterestLoading,
} from "../selectors/register-your-interest.selectors";

@Injectable()
export class RegisterYourInterestFacade {
    public loading$: Observable<boolean>;
    public customerType$: Observable<CustomerType | undefined>;

    // TODO APLBLG-170621 replace with selectSignal
    constructor(private store: Store<RegisterYourInterestState>) {
        this.loading$ = this.store.select(selectRegisterYourInterestLoading);
        this.customerType$ = this.store.select(
            selectRegisterYourInterestCustomerType,
        );
    }

    public openRegisterYourInterest(): void {
        this.store.dispatch(openRegisterYourInterest());
    }

    public resetRegisterYourInterest(): void {
        this.store.dispatch(resetRegisterYourInterest());
    }

    public setCustomerType(type: CustomerType): void {
        this.store.dispatch(setCustomerType({ customerType: type }));
    }

    public resetCustomerType(): void {
        this.store.dispatch(resetCustomerType());
    }
}
